import MatchedMap from 'utilities/src/matchedMap';

import { sizeMap, sizeBackgroundMap, SizeEnum, type SizeType } from '../_size';

export const siteIconBgSizeClassesMap = new MatchedMap([
  [SizeEnum.Glyph, 'w-2.5 h-2.5'],
  [SizeEnum.IconS, 'w-3 h-3'],
  [SizeEnum.IconSM, 'w-3.25 h-3.25'],
  [SizeEnum.IconM, 'w-3.5 h-3.5'],
  [SizeEnum.IconL, 'w-5 h-5'],
  [SizeEnum.IconXL, 'w-6 h-6'],
  [SizeEnum.Icon2XL, 'w-8 h-8'],
  [SizeEnum.Icon3XL, 'w-10 h-10'],
  [SizeEnum.Icon4XL, 'w-12 h-12'],
  [SizeEnum.Icon5XL, 'w-16 h-16'],
]);

/**
 * Icon Variant Classes
 */

const iconContainerBgClasses = 'bg-site-neutrals-50 block';

/**
 * Icon Site Theme
 */

const iconSiteTheme = (size: SizeType, bg: boolean) => ({
  iconContainerBgClasses,
  iconContainerBgSizeClasses: `${sizeBackgroundMap.get(SizeEnum[size])} ${sizeMap.get(SizeEnum[size])}`,
  iconSizeClasses: bg ? siteIconBgSizeClassesMap.get(SizeEnum[size]) : sizeMap.get(SizeEnum[size]),
});

export default iconSiteTheme;
